'use client'

import {
   Badge,
   Box,
   Card,
   Container,
   Group,
   Stack,
   Text,
   ThemeIcon
} from '@blocks'
import {
   siteFeatureCardBackgroundHex,
   siteFeatureCardShadow,
   siteSectionCardRadiusPx,
   siteTextOnDarkBandHex,
   siteTextOnDarkBandMutedHex,
   siteTypographySectionLeadFontSizeDesktop,
   siteTypographySectionLeadFontSizeMobile,
   siteTypographySectionTitlePrimaryFontSizeDesktop,
   siteTypographySectionTitlePrimaryFontSizeMobile,
   siteTypographySectionTitleSecondaryFontSizeDesktop,
   siteTypographySectionTitleSecondaryFontSizeMobile
} from '@constants'
import {useMediaQuery} from '@hooks'
import {IconCheck, IconDog} from '@icons'
import {FaqInSection} from '@/blocks/site/FaqAccordion'

const features = [
   'Shampoo',
   'Flea treatment',
   'Conditioner',
   'Rinse',
   'Blow dryer',
   'Disinfectant'
]

export const DogWash = () => {
   const isMobile = useMediaQuery('(max-width: 768px)')

   return (
      <Box bg={'primary.9'}>
         <Container
            py={isMobile ? 80 : 120}
            size={'xl'}
         >
            <Stack gap={isMobile ? 50 : 70}>
               <Group
                  align={'stretch'}
                  gap={60}
                  wrap={'wrap'}
                  style={{flexWrap: 'wrap'}}
               >
                  <Stack
                     gap={30}
                     style={{flex: '1 1 340px'}}
                  >
                     <Stack gap={12}>
                        <Badge
                           size={'lg'}
                           fw={700}
                           tt={'uppercase'}
                           styles={{
                              root: {
                                 backgroundColor:
                                    'rgba(255,255,255,0.12)',
                                 color: 'white',
                                 border:
                                    '1px solid rgba(255,255,255,0.22)'
                              }
                           }}
                        >
                           Dog Wash
                        </Badge>
                        <Text
                           c={siteTextOnDarkBandHex}
                           fz={
                              isMobile
                                 ? siteTypographySectionTitlePrimaryFontSizeMobile
                                 : siteTypographySectionTitlePrimaryFontSizeDesktop
                           }
                           fw={800}
                           lh={1.05}
                        >
                           Not Just for Cars.
                        </Text>
                     </Stack>
                     <Stack gap={18}>
                        <Text
                           c={siteTextOnDarkBandMutedHex}
                           fz={
                              isMobile
                                 ? siteTypographySectionLeadFontSizeMobile
                                 : siteTypographySectionLeadFontSizeDesktop
                           }
                           fw={500}
                           lh={1.7}
                        >
                           Clean Park is not just for cars. Our dog
                           wash station makes it simple to keep your
                           dog clean without the mess at home.
                        </Text>
                        <Text
                           c={siteTextOnDarkBandMutedHex}
                           fz={
                              isMobile
                                 ? siteTypographySectionLeadFontSizeMobile
                                 : siteTypographySectionLeadFontSizeDesktop
                           }
                           fw={500}
                           lh={1.7}
                        >
                           It is a practical, easy-to-use wash station
                           designed to make bath time quicker,
                           cleaner, and more convenient for both you
                           and your dog.
                        </Text>
                     </Stack>
                  </Stack>
                  <Card
                     p={isMobile ? 36 : 44}
                     radius={siteSectionCardRadiusPx}
                     style={{
                        flex: '1 1 340px',
                        background: siteFeatureCardBackgroundHex,
                        boxShadow: siteFeatureCardShadow
                     }}
                  >
                     <Stack gap={25}>
                        <Group
                           gap={15}
                           align={'center'}
                        >
                           <ThemeIcon
                              p={12}
                              size={60}
                              color={'white'}
                              variant={'light'}
                              radius={'lg'}
                           >
                              <IconDog
                                 stroke={1.6}
                                 size={34}
                              />
                           </ThemeIcon>
                           <Text
                              c={'white'}
                              fz={
                                 isMobile
                                    ? siteTypographySectionTitleSecondaryFontSizeMobile
                                    : siteTypographySectionTitleSecondaryFontSizeDesktop
                              }
                              fw={700}
                           >
                              What&apos;s Included
                           </Text>
                        </Group>
                        <Stack gap={14}>
                           {features.map((feature) => (
                              <Group
                                 key={feature}
                                 align={'center'}
                                 gap={14}
                                 wrap={'nowrap'}
                              >
                                 <IconCheck
                                    size={18}
                                    color={'rgba(255,255,255,0.7)'}
                                 />
                                 <Text
                                    c={'white'}
                                    fz={
                                       isMobile
                                          ? siteTypographySectionLeadFontSizeMobile
                                          : siteTypographySectionLeadFontSizeDesktop
                                    }
                                    fw={500}
                                 >
                                    {feature}
                                 </Text>
                              </Group>
                           ))}
                        </Stack>
                     </Stack>
                  </Card>
               </Group>
               <FaqInSection
                  categoryPriority={'dog-wash'}
                  sectionTone={'dark'}
               />
            </Stack>
         </Container>
      </Box>
   )
}
